import * as React from 'react';
import classnames from 'classnames';
var isActive = false;

var TabPane = function TabPane(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? [] : _ref$children,
      reRender = _ref.reRender;
  isActive = isActive || active;

  if (!active && reRender) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classnames({
      hide: !active
    })
  }, isActive && children);
};

TabPane.displayName = 'RooTabPane';
export default TabPane;